function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.922 19.961C39.922 8.93854 30.9835 0 19.961 0C8.93854 0 0 8.93854 0 19.961C0 30.9835 8.93854 39.922 19.961 39.922C20.0783 39.922 20.1949 39.9196 20.3119 39.9175V24.3787H16.0234V19.3808H20.3119V15.703C20.3119 11.4376 22.9158 9.11611 26.7206 9.11611C28.5426 9.11611 30.1087 9.25195 30.5653 9.31256V13.7704H27.9416C25.8717 13.7704 25.4709 14.7542 25.4709 16.1976V19.3808H30.4203L29.7752 24.3787H25.4709V39.1508C33.8143 36.759 39.922 29.0722 39.922 19.961Z",
  fill: "#1877F2"
});

var SvgShareIconFb = function SvgShareIconFb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgShareIconFb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share-icon-fb.9b42765a.svg";
export { ForwardRef as ReactComponent };